import React, { useEffect, useState } from "react";
import AboutPart from "./AboutSection";
import Feature from "./FeatureSection";
import FaqContainer from "./FaqContainer";
import Mission from "./Mission";
import DownloadApp from "../home/DownloadApp";
import axios from "axios";
import { SERVER_URL } from "../../api/url";

const AboutMain = () => {
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(false);
  const [modal,setModal]=useState(false);
  const [title,setTitle]=useState("");
  const [description,setDescription]=useState('')

  useEffect(()=>{
    fetchServices()
  },[])
  const fetchServices = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/about/services`, {
      
      });

      const fetchedData = response.data?.data || [];
      setData(fetchedData)
  
    
     
    } catch (err) {
      
      // Handle errors (could show a toast or error message)
    } finally {
      setLoading(false);
    }
  };
  const filteredData = data?.filter(item => 
    item.title.toLowerCase() === "mission" || item.title.toLowerCase() === "vision"
  );
  
  const filteredServices = data?.filter(item => 
    item.title.toLowerCase() !== "mission" && item.title.toLowerCase() !== "vision"
  );

  const handleCloseModal = () => {
    setModal(false); 
    setTitle('');
    setDescription('')
  };
  return (
    <>
      <AboutPart />

    {
      !loading && (
        <Feature filteredServices={filteredServices} setModal={setModal} setTitle={setTitle} setDescription={setDescription}/>

       
  
      )
    }
    {
      !loading && (
        <Mission filteredData={filteredData} setModal={setModal} setTitle={setTitle} setDescription={setDescription}/>
      )
    }
     {modal && (
        <div className="modal-overlay">
          <div className="modal-content-service">
         
            <button onClick={()=>handleCloseModal()} className="close-modal-btn-service">
              ×
            </button>
            <div style={{padding:10}}>
              <div style={{fontSize:18,paddingBottom:10,fontWeight:"bold"}}>{title}</div>
              <div>{description}</div>
            </div>
          </div>
        </div>
      )}
      <FaqContainer />

     
      <DownloadApp />
    
    </>
  );
};

export default AboutMain;
